import React, { useEffect, useRef, useState } from "react";
import {
  Container,
  Grid,
  Card,
  CardHeader,
  CardContent,
  CardActions,
  Typography,
  Button,
  Divider,
  List,
  ListItem,
  ListItemIcon,
  ListItemText,
  Box,
  Stack,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  TextField,
  AppBar,
  Toolbar,
  IconButton,
  Slide,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  Radio,
  OutlinedInput,
  FormLabel,
  FormControlLabel,
  Checkbox,
  Switch,
} from "@mui/material";

import { useDispatch, useSelector } from "react-redux";
import { useLocation } from "react-router-dom";
import CloseIcon from "@mui/icons-material/Close";
import SubscriptionPlanTable from "./SubscriptionPlanTable";
import {
  createPlanRequest,
  fetchPlansRequest,
  updatePlanRequest,
  fetchAppSubscriptionRequest,
  purchaseDirectPlan,
  manuallyExpireSubscriptionRequest,
  payInstallmentRequest,
  fetchChildSubscriptionRequest,
  payExternalFeaturesRequest,
  fetchExternalSubscriptionRequest,
  updateBenefitAndFeatureRequest,
} from "../../../redux/sagas/Subscription/SubscriptionSlice";
import CustomModal from "../../Comman/Modal";
import { toast } from "react-toastify";
import CheckIcon from "@mui/icons-material/Check";
import { fetchCustomerListRequest } from "../../../redux/customer/CustomerSlice";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import dayjs, { Dayjs } from "dayjs";
import TableCompo from "../Table/TableCompo";
import { RiDeleteBin6Line, RiEdit2Fill } from "react-icons/ri";
import { getBenefitsAndFeatures } from "../../../redux/Configuration/configurationSlice";
import {
  subscriptionFrequency,
  benefitFields,
  featureOptions,
} from "../../../configs/constants";
import { SubscriptionsList } from "./SubscriptionList";
import { fetchJewellersSidebarRequest } from "../../../redux/JewellerList/JewellerSlice";
import { RadioGroup } from "@mui/material";
import moment from "moment";
import { apiRequest } from "../../../redux/Reports/reportsSlice";
import useCsvConverter from "../../../hooks/convertToCSV";
import { getApplicableCouponsRequest } from "../../../redux/sagas/Coupon/CouponSlice";

const subscriptionIdOf = (subscription) => {
  if (!subscription) return "";
  if (typeof subscription === "object") {
    return String(subscription._id || subscription.id || "");
  }
  return String(subscription);
};

const buildEditableBenefits = (planBenefits = [], templates = benefitFields) => {
  const templateList =
    Array.isArray(templates) && templates.length ? templates : benefitFields;
  const existing = Array.isArray(planBenefits) ? planBenefits : [];
  const keys = [];

  templateList.forEach((item) => {
    if (item?.key && !keys.includes(item.key)) keys.push(item.key);
  });
  existing.forEach((item) => {
    if (item?.key && !keys.includes(item.key)) keys.push(item.key);
  });

  return keys.map((key) => {
    const template = templateList.find((item) => item.key === key) || {};
    const current = existing.find((item) => item.key === key) || {};
    return {
      key,
      label: current.label || template.label || key,
      restricted: Boolean(current.restricted),
      value: current.value ?? template.value ?? 0,
      description: current.description ?? template.description ?? "",
    };
  });
};

const JewellerSubscription = () => {
  const {
    appSubscriptionData = [],
    appSubscriptionTotal = 0,
    data = [],
    childSubscriptionData = [],
  } = useSelector((state) => state.subscriptionPlan || {});
  const { jewellersSidebar = [], loading } = useSelector(
    (state) => state.jeweller,
  );
  const reduxCouponInfo = useSelector(
    (state) => state.coupon.coupon_info || {},
  );
  const featuresData = useSelector(
    (state) => state?.appConfig?.benefitsAndFeatures?.FeatureOptions || {},
  );
  const benefitsData = useSelector(
    (state) => state?.appConfig?.benefitsAndFeatures?.benefitFields || [],
  );
  const benefitFeatureUpdating = useSelector(
    (state) => state.subscriptionPlan?.benefitFeatureUpdating,
  );
  const benefitFeatureUpdate = useSelector(
    (state) => state.subscriptionPlan?.benefitFeatureUpdate,
  );
  const plansLoading = useSelector(
    (state) => state.subscriptionPlan?.loading,
  );
  const { externalSubscriptionData = [] } = useSelector(
    (state) => state.subscriptionPlan || {},
  );

  const couponError = useSelector((state) => state.coupon.error);
  const dispatch = useDispatch();
  const [open, setOpen] = useState(false);
  const [selectedCustomer, setSelectedCustomer] = useState("");
  const [startDate, setStartDate] = useState(dayjs());
  const [endDate, setEndDate] = useState(dayjs());
  const [amount, setAmount] = useState("");
  const [page, setPage] = useState(0);
  const [limit, setLimit] = useState(10);
  const [searchText, setSearchText] = useState("");
  const [selectedPlan, setSelectedPlan] = useState(null);
  const Transition = React.forwardRef(function Transition(props, ref) {
    return <Slide direction="up" ref={ref} {...props} />;
  });

  const location = useLocation();
  const [expireDialog, setExpireDialog] = useState(false);
  const [expireReason, setExpireReason] = useState("");
  const [selectedSubscription, setSelectedSubscription] = useState(null);
  const [detailsDialog, setDetailsDialog] = useState(false);
  const [detailsData, setDetailsData] = useState(null);
  const [isInstallmentMode, setIsInstallmentMode] = useState(false);
  const [installmentPlanId, setInstallmentPlanId] = useState("");
  const [selectedInstallmentRow, setSelectedInstallmentRow] = useState(null);
  const [updatePlanOpen, setUpdatePlanOpen] = useState(false);
  const [editFeatures, setEditFeatures] = useState([]);
  const [editBenefits, setEditBenefits] = useState([]);
  const handledBenefitUpdate = useRef(null);
  const [childDialog, setChildDialog] = useState(false);
  const [childLoading, setChildLoading] = useState(false);
  const [couponCode, setCouponCode] = useState("");
  const [couponInfo, setCouponInfo] = useState(null);
  const [discountAmount, setDiscountAmount] = useState(0);
  const [payableAmount, setPayableAmount] = useState(0);
  const [didVerify, setDidVerify] = useState(false);
  const [tds, setTds] = useState(0);
  const [externalFeaturesDialog, setExternalFeaturesDialog] = useState(false);
  const [externalFeaturesRow, setExternalFeaturesRow] = useState(null);
  const [externalComment, setExternalComment] = useState("");
  const [externalAmount, setExternalAmount] = useState("");
  const [externalSelectedFeatures, setExternalSelectedFeatures] = useState([]);
  const [viewFeaturesDialog, setViewFeaturesDialog] = useState(false);
  const [viewFeaturesList, setViewFeaturesList] = useState([]);

  const handleViewFeaturesList = (features) => {
    setViewFeaturesList(features || []);
    setViewFeaturesDialog(true);
  };
  const handleAddExternalFeatures = (row) => {
    setExternalFeaturesRow(row);
    setExternalComment("");
    setExternalAmount("");
    dispatch(
      fetchExternalSubscriptionRequest({
        jewellerId: row?.jeweller?._id || row?.jeweller,
        subscriptionId: row?.subscription?._id || row?.subscription,
      }),
    );
    const baseFeatures = (row?.features || []).map((f) => f.toLowerCase());

    const externalFeatures = (externalSubscriptionData || []).flatMap((item) =>
      (item.features || []).map((f) => f.toLowerCase()),
    );

    const combinedFeatures = Array.from(
      new Set([...baseFeatures, ...externalFeatures]),
    );
    setExternalSelectedFeatures(combinedFeatures);
    setExternalFeaturesDialog(true);
  };

  const handleSubmitExternalFeatures = () => {
    if (!externalAmount) {
      return toast.warning("Amount is required");
    }

    const existingFeatures = Array.from(
      new Set([
        ...(externalFeaturesRow?.features || []).map((f) => f.toLowerCase()),
        ...(externalSubscriptionData || []).flatMap((item) =>
          (item.features || []).map((f) => f.toLowerCase()),
        ),
      ]),
    );

    const newlySelectedFeatures = externalSelectedFeatures.filter(
      (f) => !existingFeatures.includes(f),
    );

    if (newlySelectedFeatures.length === 0) {
      return toast.warning("Please select at least one new feature");
    }

    const payload = {
      jeweller: externalFeaturesRow?.jeweller?._id,
      subscription:
        externalFeaturesRow?.subscription?._id ||
        externalFeaturesRow?.subscription,
      features: newlySelectedFeatures,
      startDate: externalFeaturesRow?.startDate,
      endDate: externalFeaturesRow?.endDate,
      status: externalFeaturesRow?.status,
      amount: Number(externalAmount),
      comment: externalComment,
    };

    dispatch(payExternalFeaturesRequest(payload));
    setExternalFeaturesDialog(false);
    setExternalFeaturesRow(null);
    setExternalComment("");
    setExternalAmount("");
    setExternalSelectedFeatures([]);
  };
  const handleExpireSubscription = (row) => {
    setSelectedSubscription(row);
    setExpireReason("");
    setExpireDialog(true);
  };
  const confirmExpireSubscription = () => {
    if (!expireReason?.trim()) {
      return toast.warning("Reject reason is required");
    }

    dispatch(
      manuallyExpireSubscriptionRequest({
        subscriptionId: selectedSubscription?._id,
        rejectReason: expireReason,
      }),
    );

    setExpireDialog(false);
    setExpireReason("");
    setSelectedSubscription(null);
  };
  const handleViewDetails = (row) => {
    setDetailsData(row);
    setDetailsDialog(true);
  };
  const handlePayInstallment = (row) => {
    setSelectedInstallmentRow(row);
    setIsInstallmentMode(true);
    setCouponCode("");
    setCouponInfo(null);
    setDiscountAmount(0);
    setPayableAmount(0);
    setDidVerify(false);
    setTds(0);

    setSelectedCustomer(row.jeweller?._id || row.jeweller);
    setStartDate(dayjs(row.startDate));
    setEndDate(dayjs(row.endDate));

    const planId = subscriptionIdOf(row.subscription);
    setInstallmentPlanId(planId);

    const matchedPlan = data.find(
      (plan) => subscriptionIdOf(plan) === planId,
    );
    const populatedPlan =
      row.subscription &&
      typeof row.subscription === "object" &&
      (row.subscription.planName || row.subscription.amount != null)
        ? row.subscription
        : null;

    setSelectedPlan(matchedPlan || populatedPlan || null);
    setAmount("");
    dispatch(fetchPlansRequest({ page: 1, limit: 500 }));
    dispatch(getBenefitsAndFeatures());
    setOpen(true);
  };

  const openUpdatePlan = () => {
    const plan =
      data.find(
        (item) => subscriptionIdOf(item) === String(installmentPlanId),
      ) || selectedPlan;
    const planId = subscriptionIdOf(plan) || installmentPlanId;
    if (!planId) {
      toast.warning("This record does not have a subscription plan");
      return;
    }
    if (!plan?.planName && !Array.isArray(plan?.features)) {
      toast.info("Plan details are still loading");
      return;
    }

    setEditFeatures(Array.isArray(plan.features) ? [...plan.features] : []);
    setEditBenefits(buildEditableBenefits(plan.benefits, benefitsData));
    setUpdatePlanOpen(true);
  };

  const handleSaveBenefitAndFeature = () => {
    const planId = subscriptionIdOf(selectedPlan) || installmentPlanId;
    if (!planId) {
      toast.warning("This record does not have a subscription plan");
      return;
    }

    const invalidBenefit = editBenefits.find(
      (item) =>
        item.restricted && (!Number(item.value) || Number(item.value) <= 0),
    );
    if (invalidBenefit) {
      toast.error(`Enter a valid limit for ${invalidBenefit.label}`);
      return;
    }

    const optionList = Object.values(featuresData || {}).filter(
      (feature) => feature && typeof feature !== "object",
    );
    const canonicalFeatures = [
      ...new Set(
        editFeatures.map((feature) => {
          const match = optionList.find(
            (option) =>
              String(option).toLowerCase() === String(feature).toLowerCase(),
          );
          return match || feature;
        }),
      ),
    ];

    dispatch(
      updateBenefitAndFeatureRequest({
        _id: planId,
        features: canonicalFeatures,
        benefits: editBenefits.map((item) => ({
          key: item.key,
          label: item.label,
          restricted: Boolean(item.restricted),
          value: Number(item.value) || 0,
          description: item.description || "",
        })),
      }),
    );
  };
  const handleOpenChild = (row) => {
    setSelectedInstallmentRow(row);
    setChildDialog(true);
    console.log("row._id for child", row._id);
    dispatch(
      fetchChildSubscriptionRequest({
        parentId: row._id,
      }),
    );
    console.log("row", row);
    dispatch(
      fetchExternalSubscriptionRequest({
        jewellerId: row?.jeweller?._id || row?.jeweller,
        subscriptionId: row?.subscription?._id || row?.subscription,
      }),
    );
  };

  const calculateAmountWithGST = (amount) => {
    return Number((Number(amount) * 1.18).toFixed(2));
  };

  const getPlanEndDate = (start, validity) => {
    let end = start;
    switch (validity) {
      case subscriptionFrequency.daily:
        end = start.add(1, "day");
        break;
      case subscriptionFrequency.weekly:
        end = start.add(7, "day");
        break;
      case subscriptionFrequency.biweekly:
        end = start.add(14, "day");
        break;
      case subscriptionFrequency.monthly:
        end = start.add(30, "day");
        break;
      case subscriptionFrequency.quarterly:
        end = start.add(90, "day");
        break;
      case subscriptionFrequency.half_Yearly:
        end = start.add(180, "day");
        break;
      case subscriptionFrequency.yearly:
        end = start.add(365, "day");
        break;
      default:
        end = start;
    }
    return end;
  };

  const columns = [
    {
      field: "planName",
      headerName: "Plan Name",
      render: (_val, row) => row?.subscription?.planName || "-",
    },
    {
      field: "createdAt",
      headerName: "Date",
      render: (val, row) => {
        return row?.createdAt
          ? new Date(row.createdAt).toLocaleString("en-IN", {
              day: "2-digit",
              month: "short",
              year: "numeric",
              hour: "2-digit",
              minute: "2-digit",
              hour12: true,
            })
          : "N.A";
      },
    },
    {
      field: "jeweller",
      headerName: "Jeweller Name",
      render: (value, row) => row.jeweller?.jewellerName || "-",
    },
    // { field: 'validity', headerName: 'Validity' },
    { field: "planAmount", headerName: "Plan Amount" },
    {
      field: "tds",
      headerName: "TDS Amount",
      render: (value, row) => (row.totalTds > 0 ? `₹${row.totalTds.toFixed(2)}` : "-"),
    },
    {
      field: "discountAmount",
      headerName: "Discount Amount",
      render: (value, row) => row.discountAmount ? row.discountAmount.toFixed(2) : "-",
    },
    {
      field: "payableAmount",
      headerName: "Payable Amount",
      render: (value, row) => row.payableAmount ? row.payableAmount.toFixed(2) : "-",
    },
    {
      field: "payableAmountWithGST",
      headerName: "Payable Amount With GST",
      render: (value, row) => row.payableAmountWithGST ? row.payableAmountWithGST.toFixed(2) : "-",
    },
    {
      field: "paidAmount",
      headerName: "Total Paid Amount",
      render: (value, row) =>
        row.totalPaidAmount != null ? row.totalPaidAmount.toFixed(2) : (row.amount ?? "-"),
    },
    {
      field: "pendingAmount",
      headerName: "Total Pending Amount",
      render: (value, row) =>
        row.totalPendingAmount != null
          ? row.totalPendingAmount.toFixed(2)
          : (row.pendingAmount ?? "-"),
    },
    {
      field: "coupon",
      headerName: "Coupon",
      render: (value, row) => row.coupon || "-",
    },
    {
      field: "startDate",
      headerName: "Start Date",
      render: (value, row) => moment(value).format("DD-MMM-YYYY"),
    },
    {
      field: "endDate",
      headerName: "End Date",
      render: (value, row) => moment(value).format("DD-MMM-YYYY"),
    },
    {
      field: "status",
      headerName: "Status",
      render: (value, row) => {
        const getColor = () => {
          switch (value) {
            case "Active":
              return "success"; // Green
            case "PrePaid":
              return "warning"; // Orange
            case "Expired":
              return "error"; // Red
            default:
              return "primary";
          }
        };

        return (
          <Button
            variant="contained"
            color={getColor()}
            size="small"
            disabled={value === "Expired"}
            onClick={() => handleExpireSubscription(row)}
          >
            {value}
          </Button>
        );
      },
    },
    {
      field: "details",
      headerName: "Details",
      render: (value, row) =>
        row?.expiredBy ? (
          <Button
            variant="outlined"
            color="info"
            size="small"
            onClick={() => handleViewDetails(row)}
            sx={{
              borderRadius: 2,
              textTransform: "none",
              fontWeight: 600,
            }}
          >
            View
          </Button>
        ) : (
          "-"
        ),
    },
    {
      field: "pay",
      headerName: "Pay",
      render: (value, row) =>
        row?.pendingAmount > 0 && row?.status === "Active" ? (
          <Button
            variant="contained"
            color="primary"
            size="small"
            onClick={() => handlePayInstallment(row)}
            sx={{
              borderRadius: 2,
              textTransform: "none",
              fontWeight: 600,
            }}
          >
            Pay
          </Button>
        ) : (
          "-"
        ),
    },
    {
      field: "subscriptionDetails",
      headerName: "Subscription Details",
      render: (value, row) => (
        <Button
          variant="outlined"
          color="primary"
          size="small"
          onClick={() => handleOpenChild(row)}
        >
          View
        </Button>
      ),
    },
    {
      field: "addExternalFeatures",
      headerName: "Add Features",
      render: (value, row) =>
        row?.status === "Active" ? (
          <Button
            variant="contained"
            color="secondary"
            size="small"
            onClick={() => handleAddExternalFeatures(row)}
            sx={{
              borderRadius: 2,
              textTransform: "none",
              fontWeight: 600,
            }}
          >
            Add New Features
          </Button>
        ) : (
          "-"
        ),
    },
  ];

  function displayPlanValidity(planValidity) {
    switch (planValidity) {
      case subscriptionFrequency.daily:
        return "Day";
      case subscriptionFrequency.weekly:
        return "Week";
      case subscriptionFrequency.biweekly:
        return "2 Weeks";
      case subscriptionFrequency.monthly:
        return "Month";
      case subscriptionFrequency.quarterly:
        return "Quarter";
      case subscriptionFrequency.half_Yearly:
        return "Half Year";
      case subscriptionFrequency.yearly:
        return "Year";
      default:
        return planValidity; // or "";
    }
  }
  const resetFormFields = () => {
    setSelectedCustomer("");
    setStartDate(dayjs());
    setEndDate(dayjs());
    setAmount("");
    setSelectedPlan(null);
    setIsInstallmentMode(false);
    setInstallmentPlanId("");
    setSelectedInstallmentRow(null);
    setUpdatePlanOpen(false);
    setEditFeatures([]);
    setEditBenefits([]);
    setTds(0);
  };
  const handleClose = () => {
    //setUpgradePlan(null)
    setOpen(false);
    resetFormFields();
  };

  const onVerify = () => {
    if (!couponCode.trim()) {
      toast.error("Please enter coupon code");
      return;
    }
    console.log("couponCode", couponCode);

    setDidVerify(true);

    dispatch(getApplicableCouponsRequest(couponCode));
  };

  useEffect(() => {
    if (!didVerify) return;

    if (couponError) {
      toast.error(couponError);
      setCouponInfo(null);
      setDiscountAmount(0);
      setPayableAmount(Number(amount || 0));
      return;
    }

    if (reduxCouponInfo && Object.keys(reduxCouponInfo).length > 0) {
      setCouponInfo(reduxCouponInfo);

      const planAmount = Number(selectedPlan?.amount || amount || 0);

      let discount = 0;

      if (
        reduxCouponInfo.calculationType === "Percentage" ||
        reduxCouponInfo.calculationType === 1
      ) {
        discount = Math.round(
          (planAmount * Number(reduxCouponInfo.value || 0)) / 100,
        );
      } else {
        discount = Number(reduxCouponInfo.value || 0);
      }

      const payable = Math.max(planAmount - discount, 0);

      setDiscountAmount(discount);
      setPayableAmount(payable);

      toast.success("Coupon applied successfully");
    }
  }, [reduxCouponInfo, couponError, didVerify, selectedPlan, amount]);

  const handelSubmit = () => {
    if (
      !startDate ||
      !endDate ||
      !amount ||
      !selectedPlan ||
      !selectedCustomer
    ) {
      return toast.warning("all fields are required.");
    }

    if (endDate.valueOf() < startDate.valueOf()) {
      return toast.warning("end date should be greater than start date");
    }

    if (amount < 0) {
      return toast.warning("amount should be a positive number");
    }

    if (isInstallmentMode) {
      let payload = {
        parentPlanId: selectedInstallmentRow?._id,
        amount: Number(amount),
        tds: Number(tds || 0),
      };
      console.log("payload payInstallmentRequest", payload);

      dispatch(payInstallmentRequest(payload));
      resetFormFields();
      setOpen(false);
      return;
    }
    let payload = {
      startDate: startDate.valueOf(),
      endDate: endDate.valueOf(),
      amount: Number(amount),
      subscription: selectedPlan._id,
      jeweller: selectedCustomer,
      coupon: couponInfo?.code || "",
      discountAmount: Number(discountAmount || 0),
      payableAmount: Number(
        discountAmount > 0 ? payableAmount : selectedPlan?.amount || 0,
      ),
      tds: Number(tds || 0),
    };
    dispatch(purchaseDirectPlan(payload));
    resetFormFields();
    setOpen(false);
  };

  useEffect(() => {
    dispatch(fetchJewellersSidebarRequest({ allActive: true }));
    dispatch(
      fetchAppSubscriptionRequest({
        page: page + 1,
        limit: limit,
        search: searchText,
      }),
    );
  }, [page, limit, searchText]);

  useEffect(() => {
    if (!isInstallmentMode || !installmentPlanId) return;
    const matchedPlan = data.find(
      (plan) => subscriptionIdOf(plan) === String(installmentPlanId),
    );
    if (matchedPlan) {
      setSelectedPlan(matchedPlan);
    }
  }, [data, isInstallmentMode, installmentPlanId]);

  useEffect(() => {
    const token = benefitFeatureUpdate?.token;
    if (!token || handledBenefitUpdate.current === token) return;
    handledBenefitUpdate.current = token;
    if (!isInstallmentMode) return;

    const plan = benefitFeatureUpdate.plan;
    if (plan) {
      setSelectedPlan((current) => ({
        ...(current || {}),
        ...plan,
        features: plan.features ?? current?.features,
        benefits: plan.benefits ?? current?.benefits,
      }));
    }
    setUpdatePlanOpen(false);
  }, [benefitFeatureUpdate, isInstallmentMode]);

  useEffect(() => {
    if (location?.state?.fromUpgrade) {
      const planToSelect = location.state.planToSelect;
      const selected = data.find((plan) => plan._id === planToSelect?._id);
      if (selected) {
        const start = dayjs();
        const end = getPlanEndDate(start, selected.validity);
        setSelectedPlan(selected);
        setStartDate(start);
        setEndDate(end);
        setOpen(true);
      }
    }
  }, [data, location?.state]);

  const { convertToCsv } = useCsvConverter();

  const triggerCsvDownload = (csvText, filename) => {
    const blob = new Blob([csvText], { type: "text/csv" });
    const url = window.URL.createObjectURL(blob);

    const a = document.createElement("a");
    a.href = url;
    a.download = filename;
    a.click();

    window.URL.revokeObjectURL(url);
  };

  const handleDownloadStoreCsv = () => {
    console.log("Store CSV API called");

    dispatch(
      apiRequest({
        method: "GET",
        endpoint: "/api/v1/subscription/jewellerAppSubscriptionCsv",
        query: {},
        callback: (response) => {
          const csv = convertToCsv(response?.data || []);
          triggerCsvDownload(csv, "jewellerAppSubscription.csv");
        },
      }),
    );
  };
  const handleTableChange = (action, payload) => {
    if (action === "changePage") {
      setPage(payload.page);
    }

    if (action === "changeRowsPerPage") {
      setLimit(payload.rowsPerPage);
      setPage(0);
    }

    if (action === "search") {
      setSearchText(payload.searchText);
      setPage(0);
    }
  };
  const tableHeadStyle = {
    padding: "16px",
    textAlign: "left",
    fontSize: "14px",
    fontWeight: 700,
  };

  const tableBodyStyle = {
    padding: "16px",
    fontSize: "14px",
    fontWeight: 500,
  };
  const safeData = Array.isArray(appSubscriptionData)
    ? appSubscriptionData
    : [];

  const matchedInstallmentPlans = isInstallmentMode
    ? data.filter(
        (plan) => subscriptionIdOf(plan) === String(installmentPlanId),
      )
    : [];
  const visiblePlans = isInstallmentMode
    ? matchedInstallmentPlans.length
      ? matchedInstallmentPlans
      : selectedPlan
        ? [selectedPlan]
        : []
    : data;

  const configuredFeatures = Object.values(featuresData || {}).filter(
    (feature) => feature && typeof feature !== "object",
  );
  const featureChoices = [
    ...new Set([
      ...(configuredFeatures.length ? configuredFeatures : featureOptions),
      ...editFeatures,
    ]),
  ];

  const isFeatureChecked = (option) =>
    editFeatures.some(
      (feature) =>
        String(feature).toLowerCase() === String(option).toLowerCase(),
    );

  const toggleFeature = (option, checked) => {
    setEditFeatures((current) => {
      const without = current.filter(
        (feature) =>
          String(feature).toLowerCase() !== String(option).toLowerCase(),
      );
      return checked ? [...without, option] : without;
    });
  };

  return (
    <Box sx={{ width: "100%", height: "100vh", overflow: "hidden" }}>
      <Box sx={{ height: "100%", overflowY: "auto", p: 2 }}>
        <Box
          sx={{
            width: "100%",
            maxWidth: "100%",
            mx: "auto",
            mt: 0,
            background: "#fff",
            borderRadius: 2,
            boxShadow: "0 2px 8px rgba(0,0,0,0.1)",
            p: { xs: 2, md: 4 },
          }}
        >
          <Typography fontWeight={700} fontSize={24} mb={2} fontFamily="Aeonik">
            Jeweller Subscription Plan's
          </Typography>

          <Button
            variant="contained"
            color="primary"
            onClick={() => {
              dispatch(fetchPlansRequest({ page: 1, limit: 500 }));
              setOpen(true);
            }}
          >
            Add New Subscription
          </Button>

          <Dialog open={open} onClose={handleClose} fullScreen>
            <DialogTitle sx={{ display: "flex", alignItems: "center", gap: 1 }}>
              {isInstallmentMode ? "Pay Installment" : "New Subscription"}
            </DialogTitle>
            <DialogContent>
              <Box
                sx={{
                  maxWidth: "1000px",
                  mx: "auto", // center horizontally
                  width: "100%",
                }}
              >
                <FormControl sx={{ mt: 2 }} fullWidth margin="normal">
                  <InputLabel>Select Jeweller</InputLabel>
                  <Select
                    value={selectedCustomer}
                    disabled={isInstallmentMode}
                    onChange={(e) => setSelectedCustomer(e.target.value)}
                    input={<OutlinedInput label="Select Jeweller" />}
                  >
                    {jewellersSidebar.map((item) => (
                      <MenuItem key={item.id} value={item.id}>
                        {item.jewellerName}
                      </MenuItem>
                    ))}
                  </Select>
                </FormControl>
                <LocalizationProvider dateAdapter={AdapterDayjs}>
                  <Box
                    sx={{
                      display: "flex",
                      gap: 2,
                      mt: 2,
                      flexWrap: "wrap",
                    }}
                  >
                    {/* Start Date */}
                    <DatePicker
                      label="Start Date"
                      value={startDate}
                      format="DD/MM/YYYY"
                      disabled={isInstallmentMode}
                      onChange={(newValue) => setStartDate(newValue)}
                      renderInput={(params) => <TextField {...params} />}
                    />

                    {/* End Date */}
                    <DatePicker
                      label="End Date"
                      value={endDate}
                      format="DD/MM/YYYY"
                      disabled={isInstallmentMode}
                      onChange={(newValue) => setEndDate(newValue)}
                      renderInput={(params) => <TextField {...params} />}
                    />
                  </Box>
                </LocalizationProvider>
                <TextField
                  label="Paid Amount"
                  type="number"
                  value={amount}
                  onChange={(e) => setAmount(e.target.value)}
                  fullWidth
                  sx={{ mt: 2 }}
                />

                <TextField
                  label="TDS Amount (Optional)"
                  type="number"
                  value={tds}
                  onChange={(e) => setTds(e.target.value)}
                  fullWidth
                  sx={{ mt: 2 }}
                  inputProps={{ min: 0 }}
                />

                {!isInstallmentMode && (
                  <Box mt={2}>
                    <Stack direction="row" spacing={1}>
                      <TextField
                        fullWidth
                        label="Coupon Code"
                        value={couponCode}
                        onChange={(e) => setCouponCode(e.target.value)}
                      />

                      <Button
                        variant="contained"
                        onClick={onVerify}
                        disabled={!selectedPlan}
                      >
                        Verify
                      </Button>
                    </Stack>

                    {couponInfo?.code && (
                      <Box mt={2}>
                        <Typography color="success.main" fontWeight={600}>
                          Coupon Applied : {couponInfo.code}
                        </Typography>

                        <Typography color="success.main">
                          Discount Amount : ₹{discountAmount}
                        </Typography>

                        <Typography fontWeight={700}>
                          Payable Amount : ₹{payableAmount}
                        </Typography>
                      </Box>
                    )}
                  </Box>
                )}

                <Typography
                  variant="subtitle1"
                  align="center"
                  color="text.secondary"
                  sx={{ mb: 2, mt: 2 }}
                >
                  {isInstallmentMode
                    ? "Subscription plan for this installment"
                    : "Choose the plan for jeweller"}
                </Typography>

                {isInstallmentMode && visiblePlans.length === 0 && (
                  <Typography align="center" color="text.secondary" sx={{ my: 3 }}>
                    {plansLoading
                      ? "Loading the subscription plan for this record..."
                      : "No subscription plan matches this record."}
                  </Typography>
                )}

                <Grid container spacing={3} justifyContent="center">
                  {visiblePlans.map((plan) => {
                    return (
                        <Grid
                          item
                          key={plan._id || plan.planName}
                          xs={12}
                          sm={6}
                          md={4}
                          lg={3}
                        >
                          <Card
                            onClick={() => {
                              if (isInstallmentMode) return;

                              const start = dayjs();
                              let end = start;

                              switch (plan.validity) {
                                case subscriptionFrequency.daily:
                                  end = start.add(1, "day");
                                  break;

                                case subscriptionFrequency.weekly:
                                  end = start.add(7, "day");
                                  break;

                                case subscriptionFrequency.biweekly:
                                  end = start.add(14, "day");
                                  break;

                                case subscriptionFrequency.monthly:
                                  end = start.add(30, "day");
                                  break;

                                case subscriptionFrequency.quarterly:
                                  end = start.add(90, "day");
                                  break;

                                case subscriptionFrequency.half_Yearly:
                                  end = start.add(180, "day");
                                  break;

                                case subscriptionFrequency.yearly:
                                  end = start.add(365, "day");
                                  break;

                                default:
                                  end = start;
                              }

                              setSelectedPlan(plan);
                              // setAmount(plan.amount);
                              setPayableAmount(Number(plan.amount));
                              setDidVerify(false);
                              setDiscountAmount(0);
                              setCouponCode("");
                              setCouponInfo(null);
                              setStartDate(start);
                              setEndDate(end);
                            }}
                            sx={{
                              height: "100%",
                              backgroundColor:
                                plan._id == selectedPlan?._id ? "gold" : "",
                              display: "flex",
                              flexDirection: "column",
                              borderRadius: 3,
                              boxShadow: 3,
                              transition:
                                "transform 0.3s ease, box-shadow 0.3s ease",
                              "&:hover": {
                                transform: "translateY(-6px)",
                                boxShadow: 6,
                              },
                            }}
                          >
                            {/* Title */}
                            <CardHeader
                              title={plan.planName}
                              titleTypographyProps={{
                                align: "center",
                                fontWeight: "bold",
                                variant: "h6",
                              }}
                              sx={{
                                backgroundColor: "primary.main",
                                color: "white",
                                py: 1.5,
                              }}
                            />

                            {/* Card Body */}
                            <CardContent sx={{ flexGrow: 1 }}>
                              {/* Price */}
                              <Typography
                                component="h2"
                                variant="h3"
                                color="text.primary"
                                align="center"
                                fontWeight="bold"
                              >
                                ₹{calculateAmountWithGST(plan.amount)}
                              </Typography>
                              <Typography
                                variant="caption"
                                align="center"
                                color="text.secondary"
                                display="block"
                              >
                                ₹{plan.amount} + 18% GST
                              </Typography>
                              <Typography
                                variant="subtitle1"
                                align="center"
                                color="text.secondary"
                                sx={{ mb: 2 }}
                              >
                                per {displayPlanValidity(plan.validity)}
                              </Typography>

                              {/* Features */}
                              <Divider sx={{ my: 2 }} />
                              <Typography
                                variant="subtitle1"
                                fontWeight="bold"
                                gutterBottom
                                color="primary"
                              >
                                Features
                              </Typography>
                              <List dense>
                                {(plan.features || []).map((feature) => (
                                  <ListItem key={feature} disableGutters>
                                    <ListItemIcon>
                                      <CheckIcon color="success" />
                                    </ListItemIcon>
                                    <ListItemText primary={feature} />
                                  </ListItem>
                                ))}
                              </List>

                              {/* Benefits */}
                              <Divider sx={{ my: 2 }} />
                              <Typography
                                variant="subtitle1"
                                fontWeight="bold"
                                gutterBottom
                                color="primary"
                              >
                                Benefits
                              </Typography>
                              <Box
                                sx={{
                                  backgroundColor: "rgba(25, 118, 210, 0.05)",
                                  borderRadius: 2,
                                  p: 1,
                                }}
                              >
                                <List dense>
                                  {plan.benefits?.map((benefit) => (
                                    <ListItem
                                      key={benefit.description}
                                      disableGutters
                                    >
                                      <ListItemIcon>
                                        <CheckIcon color="primary" />
                                      </ListItemIcon>
                                      <ListItemText
                                        primary={
                                          benefit.restricted
                                            ? `${benefit.value} ${benefit.label} `
                                            : `Unlimited ${benefit.label} `
                                        }
                                      />
                                    </ListItem>
                                  ))}
                                </List>
                              </Box>
                            </CardContent>

                            {/* Button fixed at bottom */}
                            <CardActions
                              sx={{ justifyContent: "center", p: 2 }}
                            >
                              {isInstallmentMode ? (
                                <Button
                                  variant="contained"
                                  size="large"
                                  color="secondary"
                                  fullWidth
                                  onClick={(event) => {
                                    event.stopPropagation();
                                    openUpdatePlan();
                                  }}
                                >
                                  Update Plan
                                </Button>
                              ) : (
                                <Button
                                  variant="contained"
                                  size="large"
                                  color="primary"
                                  fullWidth
                                >
                                  Choose
                                </Button>
                              )}
                            </CardActions>
                          </Card>
                        </Grid>
                    );
                  })}
                </Grid>
              </Box>
            </DialogContent>
            <DialogActions>
              <Button onClick={handleClose} variant="outlined">
                Cancel
              </Button>
              {isInstallmentMode && (
                <Button
                  onClick={openUpdatePlan}
                  variant="contained"
                  color="secondary"
                  disabled={!installmentPlanId && !selectedPlan}
                >
                  Update Plan
                </Button>
              )}
              <Button
                onClick={handelSubmit}
                variant="contained"
                color="primary"
              >
                {isInstallmentMode ? "Pay" : "Create"}
              </Button>
            </DialogActions>
          </Dialog>

          <Dialog
            open={updatePlanOpen}
            onClose={() => {
              if (!benefitFeatureUpdating) setUpdatePlanOpen(false);
            }}
            maxWidth="md"
            fullWidth
            sx={{ zIndex: 1600 }}
          >
            <DialogTitle sx={{ fontWeight: 700 }}>
              Update Plan
              <Typography fontSize={13} color="text.secondary">
                {selectedPlan?.planName || "Subscription plan"} — benefits and
                features only
              </Typography>
            </DialogTitle>
            <DialogContent dividers>
              <Typography fontWeight={700} fontSize={18} mb={1}>
                Features
              </Typography>
              <Box
                sx={{
                  border: "1px solid #ccc",
                  borderRadius: 2,
                  p: 2,
                  mb: 3,
                  display: "flex",
                  flexWrap: "wrap",
                  gap: 1,
                }}
              >
                {featureChoices.map((option) => (
                  <FormControlLabel
                    key={option}
                    control={
                      <Checkbox
                        checked={isFeatureChecked(option)}
                        onChange={(e) => toggleFeature(option, e.target.checked)}
                      />
                    }
                    label={String(option).replace(/_/g, " ")}
                  />
                ))}
              </Box>

              <Typography fontWeight={700} fontSize={18} mb={2}>
                Benefits
              </Typography>
              {editBenefits.map((field) => (
                <Grid
                  container
                  spacing={2}
                  mb={2}
                  key={field.key}
                  alignItems="center"
                >
                  <Grid item xs={12} sm={3}>
                    <FormControlLabel
                      control={
                        <Switch
                          checked={Boolean(field.restricted)}
                          onChange={(e) => {
                            const checked = e.target.checked;
                            setEditBenefits((current) =>
                              current.map((item) =>
                                item.key === field.key
                                  ? { ...item, restricted: checked }
                                  : item,
                              ),
                            );
                          }}
                        />
                      }
                      label={field.restricted ? "Restricted" : "Unlimited"}
                    />
                  </Grid>
                  <Grid item xs={12} sm={4}>
                    <TextField
                      fullWidth
                      label={field.label}
                      type="number"
                      value={field.value}
                      disabled={!field.restricted}
                      onChange={(e) => {
                        const value = e.target.value;
                        setEditBenefits((current) =>
                          current.map((item) =>
                            item.key === field.key ? { ...item, value } : item,
                          ),
                        );
                      }}
                      inputProps={{ min: 0 }}
                    />
                  </Grid>
                  <Grid item xs={12} sm={5}>
                    <TextField
                      fullWidth
                      label="Description"
                      value={field.description}
                      onChange={(e) => {
                        const description = e.target.value;
                        setEditBenefits((current) =>
                          current.map((item) =>
                            item.key === field.key
                              ? { ...item, description }
                              : item,
                          ),
                        );
                      }}
                    />
                  </Grid>
                </Grid>
              ))}
            </DialogContent>
            <DialogActions>
              <Button
                onClick={() => setUpdatePlanOpen(false)}
                variant="outlined"
                disabled={benefitFeatureUpdating}
              >
                Back
              </Button>
              <Button
                onClick={handleSaveBenefitAndFeature}
                variant="contained"
                color="primary"
                disabled={benefitFeatureUpdating}
              >
                {benefitFeatureUpdating ? "Saving..." : "Save"}
              </Button>
            </DialogActions>
          </Dialog>

          <TableCompo
            columns={columns}
            data={safeData}
            page={page}
            limit={limit}
            totalCount={appSubscriptionTotal}
            onTableChange={handleTableChange}
            extraButtons={
              <Button
                size="sm"
                variant="outlined"
                onClick={handleDownloadStoreCsv}
              >
                Download CSV
              </Button>
            }
            // onTableChange={(action, { searchText }) => {
            //       if (action === "search") {
            //         setSearchText(searchText);
            //       }
            //     }}
          />

          <Dialog
            open={expireDialog}
            onClose={() => setExpireDialog(false)}
            maxWidth="sm"
            fullWidth
            PaperProps={{
              sx: {
                borderRadius: 4,
                overflow: "hidden",
              },
            }}
          >
            <Box
              sx={{
                background: "linear-gradient(135deg, #d32f2f 0%, #f44336 100%)",
                color: "#fff",
                px: 3,
                py: 2,
                display: "flex",
                alignItems: "center",
                justifyContent: "space-between",
              }}
            >
              <Box>
                <Typography fontSize={20} fontWeight={700}>
                  Expire Subscription
                </Typography>

                <Typography fontSize={13} sx={{ opacity: 0.9 }}>
                  This action cannot be revoked.
                </Typography>
              </Box>

              <IconButton
                onClick={() => setExpireDialog(false)}
                sx={{ color: "#fff" }}
              >
                <CloseIcon />
              </IconButton>
            </Box>
            <DialogContent sx={{ p: 3 }}>
              <Box
                sx={{
                  border: "1px solid #ffe0e0",
                  backgroundColor: "#fff5f5",
                  borderRadius: 3,
                  p: 2,
                  mb: 3,
                }}
              >
                <Typography
                  fontWeight={700}
                  fontSize={16}
                  color="error.main"
                  mb={1}
                >
                  Warning
                </Typography>

                <Typography fontSize={14} color="text.secondary">
                  You are going to expire this
                  <Box
                    component="span"
                    sx={{
                      fontWeight: 700,
                      color: "#000",
                    }}
                  >
                    {" "}
                    {selectedSubscription?.subscription?.planName ||
                      "Subscription Plan"}
                  </Box>
                  .
                </Typography>

                <Typography fontSize={14} color="text.secondary" mt={1}>
                  Once expired, this subscription plan cannot be activated
                  again.
                </Typography>
              </Box>

              <TextField
                label="Reject Reason"
                placeholder="Enter reason for expiring this subscription..."
                fullWidth
                multiline
                rows={4}
                value={expireReason}
                onChange={(e) => setExpireReason(e.target.value)}
                sx={{
                  "& .MuiOutlinedInput-root": {
                    borderRadius: 3,
                  },
                }}
              />
            </DialogContent>
            <DialogActions
              sx={{
                px: 3,
                pb: 3,
                pt: 1,
                gap: 1,
              }}
            >
              <Button
                onClick={() => setExpireDialog(false)}
                variant="outlined"
                sx={{
                  borderRadius: 2,
                  px: 3,
                  textTransform: "none",
                  fontWeight: 600,
                }}
              >
                Cancel
              </Button>

              <Button
                onClick={confirmExpireSubscription}
                variant="contained"
                color="error"
                sx={{
                  borderRadius: 2,
                  px: 3,
                  textTransform: "none",
                  fontWeight: 600,
                  boxShadow: "none",
                }}
              >
                Expire Plan
              </Button>
            </DialogActions>
          </Dialog>
          <Dialog
            open={detailsDialog}
            onClose={() => setDetailsDialog(false)}
            maxWidth="sm"
            fullWidth
            PaperProps={{
              sx: {
                borderRadius: 4,
                overflow: "hidden",
              },
            }}
          >
            <Box
              sx={{
                background: "linear-gradient(135deg, #1976d2 0%, #42a5f5 100%)",
                color: "#fff",
                px: 3,
                py: 2.5,
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center",
              }}
            >
              <Box>
                <Typography fontSize={20} fontWeight={700}>
                  Expired Subscription Details
                </Typography>

                <Typography fontSize={13} sx={{ opacity: 0.9 }}>
                  Subscription expiration information
                </Typography>
              </Box>

              <IconButton
                onClick={() => setDetailsDialog(false)}
                sx={{ color: "#fff" }}
              >
                <CloseIcon />
              </IconButton>
            </Box>
            <DialogContent sx={{ p: 3 }}>
              <Box
                sx={{
                  border: "1px solid #e3f2fd",
                  background: "#f8fbff",
                  borderRadius: 3,
                  overflow: "hidden",
                }}
              >
                <Box
                  sx={{
                    display: "flex",
                    justifyContent: "space-between",
                    px: 3,
                    py: 2,
                    borderBottom: "1px solid #edf2f7",
                  }}
                >
                  <Typography fontWeight={600} color="text.secondary">
                    Expired By
                  </Typography>

                  <Typography fontWeight={700}>
                    {detailsData?.expiredBy?.username ||
                      detailsData?.expiredBy?.name ||
                      "-"}
                  </Typography>
                </Box>

                <Box
                  sx={{
                    display: "flex",
                    justifyContent: "space-between",
                    px: 3,
                    py: 2,
                    borderBottom: "1px solid #edf2f7",
                  }}
                >
                  <Typography fontWeight={600} color="text.secondary">
                    Expired At
                  </Typography>

                  <Typography fontWeight={700}>
                    {detailsData?.expiredAt
                      ? moment(detailsData.expiredAt).format(
                          "DD-MMM-YYYY hh:mm A",
                        )
                      : "-"}
                  </Typography>
                </Box>

                <Box
                  sx={{
                    px: 3,
                    py: 2.5,
                  }}
                >
                  <Typography fontWeight={600} color="text.secondary" mb={1}>
                    Reject Reason
                  </Typography>

                  <Box
                    sx={{
                      background: "#fff",
                      border: "1px solid #e0e0e0",
                      borderRadius: 2,
                      p: 2,
                      minHeight: 80,
                    }}
                  >
                    <Typography fontSize={14}>
                      {detailsData?.rejectReason || "-"}
                    </Typography>
                  </Box>
                </Box>
              </Box>
            </DialogContent>

            <DialogActions
              sx={{
                px: 3,
                pb: 3,
              }}
            >
              <Button
                variant="contained"
                onClick={() => setDetailsDialog(false)}
                sx={{
                  borderRadius: 2,
                  px: 4,
                  textTransform: "none",
                  fontWeight: 600,
                }}
              >
                Close
              </Button>
            </DialogActions>
          </Dialog>
          <Dialog
            open={childDialog}
            onClose={() => setChildDialog(false)}
            fullWidth
            maxWidth="md"
            PaperProps={{
              sx: {
                borderRadius: 4,
                overflow: "hidden",
              },
            }}
          >
            {/* Header */}
            <Box
              sx={{
                background: "linear-gradient(135deg, #1976d2 0%, #42a5f5 100%)",
                color: "#fff",
                px: 3,
                py: 2.5,
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center",
              }}
            >
              <Box>
                <Typography fontSize={22} fontWeight={700}>
                  Installment History
                </Typography>

                <Typography fontSize={13} sx={{ opacity: 0.9 }}>
                  View all installment payment records
                </Typography>
              </Box>

              <IconButton
                onClick={() => setChildDialog(false)}
                sx={{ color: "#fff" }}
              >
                <CloseIcon />
              </IconButton>
            </Box>

            <DialogContent sx={{ p: 0, background: "#f4f7fb" }}>
              {childLoading ? (
                <Box
                  sx={{
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                    py: 8,
                  }}
                >
                  <Typography fontWeight={600}>
                    Loading installment data...
                  </Typography>
                </Box>
              ) : childSubscriptionData.length === 0 ? (
                <Box
                  sx={{
                    textAlign: "center",
                    py: 8,
                    background: "#fff",
                  }}
                >
                  <Typography fontSize={18} fontWeight={700}>
                    No Installment History
                  </Typography>

                  <Typography color="text.secondary" mt={1}>
                    No installment payments found.
                  </Typography>
                </Box>
              ) : (
                <Box sx={{ p: 3 }}>
                  <Box
                    sx={{
                      display: "grid",
                      gridTemplateColumns: "repeat(6, 1fr)",
                      gap: 2,
                      mb: 3,
                    }}
                  >
                    <Box
                      sx={{
                        p: 2,
                        borderRadius: 2,
                        bgcolor: "#c8e1f3",
                        textAlign: "center",
                      }}
                    >
                      <Typography variant="body2" color="text.secondary">
                        Plan Amount
                      </Typography>
                      <Typography
                        variant="h6"
                        fontWeight={700}
                        sx={{ color: "#1565c0" }}
                      >
                        ₹{selectedInstallmentRow?.planAmount || 0}
                      </Typography>
                    </Box>

                    <Box
                      sx={{
                        p: 2,
                        borderRadius: 2,
                        bgcolor: "#ecc6f1",
                        textAlign: "center",
                      }}
                    >
                      <Typography variant="body2" color="text.secondary">
                        Discount Amount
                      </Typography>
                      <Typography
                        variant="h6"
                        fontWeight={700}
                        sx={{ color: "#8e24aa" }}
                      >
                        {selectedInstallmentRow?.discountAmount || 0}
                      </Typography>
                    </Box>

                    <Box
                      sx={{
                        p: 2,
                        borderRadius: 2,
                        bgcolor: "#eed7ca",
                        textAlign: "center",
                      }}
                    >
                      <Typography variant="body2" color="text.secondary">
                        Payable Amount With GST
                      </Typography>
                      <Typography variant="h6" fontWeight={700}>
                        {selectedInstallmentRow?.payableAmountWithGST || 0}
                      </Typography>
                    </Box>

                    <Box
                      sx={{
                        p: 2,
                        borderRadius: 2,
                        bgcolor: "#c0ecc4",
                        textAlign: "center",
                      }}
                    >
                      <Typography variant="body2" color="text.secondary">
                        Total Paid
                      </Typography>
                      <Typography
                        variant="h6"
                        fontWeight={700}
                        color="success.main"
                      >
                        ₹{selectedInstallmentRow?.totalPaidAmount || 0}
                      </Typography>
                    </Box>

                    <Box
                      sx={{
                        p: 2,
                        borderRadius: 2,
                        bgcolor: "#a092f0",
                        textAlign: "center",
                      }}
                    >
                      <Typography variant="body2" color="#000">
                        Total TDS
                      </Typography>
                      <Typography variant="h6" fontWeight={700} color="#000">
                        ₹{selectedInstallmentRow?.totalTds || 0}
                      </Typography>
                    </Box>

                    <Box
                      sx={{
                        p: 2,
                        borderRadius: 2,
                        bgcolor: "#f5d6a3",
                        textAlign: "center",
                      }}
                    >
                      <Typography variant="body2" color="text.secondary">
                        Pending Amount
                      </Typography>
                      <Typography
                        variant="h6"
                        fontWeight={700}
                        color="warning.main"
                      >
                        ₹{selectedInstallmentRow?.totalPendingAmount || 0}
                      </Typography>
                    </Box>
                  </Box>
                  <Box
                    sx={{
                      overflowX: "auto",
                      borderRadius: 3,
                      background: "#fff",
                      boxShadow: "0 4px 14px rgba(0,0,0,0.06)",
                    }}
                  >
                    <table
                      style={{
                        width: "100%",
                        borderCollapse: "collapse",
                        minWidth: "900px",
                      }}
                    >
                      <thead>
                        <tr
                          style={{
                            background:
                              "linear-gradient(135deg, #1976d2 0%, #42a5f5 100%)",
                            color: "#fff",
                          }}
                        >
                          <th style={tableHeadStyle}>#</th>
                          <th style={tableHeadStyle}>Jeweller</th>
                          <th style={tableHeadStyle}>Installment Amount</th>
                          <th style={tableHeadStyle}>Paid Amount</th>
                          <th style={tableHeadStyle}>TDS</th>
                          <th style={tableHeadStyle}>Pending Amount</th>
                          {/* <th style={tableHeadStyle}>Status</th> */}
                          <th style={tableHeadStyle}>Payment Date</th>
                        </tr>
                      </thead>

                      <tbody>
                        {childSubscriptionData.map((item, index) => (
                          <tr
                            key={item._id}
                            style={{
                              borderBottom: "1px solid #edf2f7",
                              transition: "0.2s",
                              backgroundColor: index === 0 ? "#ecd073" : "#fff",
                            }}
                          >
                            <td style={tableBodyStyle}>{index + 1}</td>

                            <td style={tableBodyStyle}>
                              {item.jeweller?.jewellerName || "-"}
                            </td>

                            <td style={tableBodyStyle}>
                              <Typography fontWeight={700} color="primary">
                                ₹{item.amount}
                              </Typography>
                            </td>

                            <td style={tableBodyStyle}>
                              <Typography fontWeight={700} color="success.main">
                                ₹{item.paidAmount}
                              </Typography>
                            </td>

                            <td style={tableBodyStyle}>
                              <Typography fontWeight={700} color="secondary">
                                ₹{item.tds || 0}
                              </Typography>
                            </td>

                            <td style={tableBodyStyle}>
                              <Typography
                                fontWeight={700}
                                color={
                                  item.pendingAmount > 0
                                    ? "warning.main"
                                    : "success.main"
                                }
                              >
                                ₹
                                {item.pendingAmount != null
                                  ? Number(item.pendingAmount).toFixed(2)
                                  : "0"}
                              </Typography>
                            </td>

                            {/* <td style={tableBodyStyle}>
                              <Box
                                sx={{
                                  display: "inline-block",
                                  px: 2,
                                  py: 0.6,
                                  borderRadius: 10,
                                  fontWeight: 700,
                                  fontSize: 12,
                                  background:
                                    item.pendingAmount > 0
                                      ? "#fff4e5"
                                      : "#e8f5e9",
                                  color:
                                    item.pendingAmount > 0
                                      ? "#ef6c00"
                                      : "#2e7d32",
                                }}
                              >
                                {item.pendingAmount > 0
                                  ? "Pending"
                                  : "Completed"}
                              </Box>
                            </td> */}

                            <td style={tableBodyStyle}>
                              {moment(item.createdAt).format(
                                "DD-MMM-YYYY hh:mm A",
                              )}
                            </td>
                          </tr>
                        ))}
                      </tbody>
                    </table>
                  </Box>
                  {/* External Features table */}
                  {externalSubscriptionData?.length > 0 && (
                    <Box sx={{ p: 3, pt: 0 }}>
                      <Typography
                        fontWeight={700}
                        fontSize={16}
                        mb={2}
                        color="secondary.main"
                        paddingTop={3}
                      >
                        Additional Features Purchased
                      </Typography>

                      <Box
                        sx={{
                          overflowX: "auto",
                          borderRadius: 3,
                          background: "#fff",
                          boxShadow: "0 4px 14px rgba(0,0,0,0.06)",
                        }}
                      >
                        <table
                          style={{
                            width: "100%",
                            borderCollapse: "collapse",
                            minWidth: "700px",
                          }}
                        >
                          <thead>
                            <tr
                              style={{
                                background:
                                  "linear-gradient(135deg, #7b1fa2 0%, #ce93d8 100%)",
                                color: "#fff",
                              }}
                            >
                              <th style={tableHeadStyle}>#</th>
                              <th style={tableHeadStyle}>Paid Amount</th>
                              <th style={tableHeadStyle}>Comment</th>
                              <th style={tableHeadStyle}>Date</th>
                              <th style={tableHeadStyle}>Features</th>
                              <th style={tableHeadStyle}>Created By</th>
                            </tr>
                          </thead>
                          <tbody>
                            {externalSubscriptionData.map((item, index) => (
                              <tr
                                key={item._id}
                                style={{ borderBottom: "1px solid #edf2f7" }}
                              >
                                <td style={tableBodyStyle}>{index + 1}</td>
                                <td style={tableBodyStyle}>
                                  <Typography
                                    fontWeight={700}
                                    color="secondary.main"
                                  >
                                    ₹{item.amount}
                                  </Typography>
                                </td>
                                <td style={tableBodyStyle}>
                                  {item.comment || "-"}
                                </td>
                                <td style={tableBodyStyle}>
                                  {item.createdAt
                                    ? moment(item.createdAt).format(
                                        "DD-MMM-YYYY hh:mm A",
                                      )
                                    : "-"}
                                </td>
                                <td style={tableBodyStyle}>
                                  <Button
                                    variant="outlined"
                                    color="secondary"
                                    size="small"
                                    onClick={() =>
                                      handleViewFeaturesList(item.features)
                                    }
                                    sx={{
                                      borderRadius: 2,
                                      textTransform: "none",
                                      fontWeight: 600,
                                    }}
                                  >
                                    View ({item.features?.length || 0})
                                  </Button>
                                </td>
                                <td style={tableBodyStyle}>
                                  {item.createdBy?.name || "-"}
                                </td>
                              </tr>
                            ))}
                          </tbody>
                        </table>
                      </Box>
                    </Box>
                  )}
                </Box>
              )}
            </DialogContent>

            <DialogActions
              sx={{
                px: 3,
                py: 2,
                borderTop: "1px solid #edf2f7",
                background: "#fff",
              }}
            >
              <Button
                onClick={() => setChildDialog(false)}
                variant="contained"
                sx={{
                  borderRadius: 2,
                  px: 4,
                  textTransform: "none",
                  fontWeight: 700,
                }}
              >
                Close
              </Button>
            </DialogActions>
          </Dialog>
          <Dialog
            open={externalFeaturesDialog}
            onClose={() => {
              setExternalFeaturesDialog(false);
              setExternalFeaturesRow(null);
              setExternalComment("");
              setExternalAmount("");
              setExternalSelectedFeatures([]);
            }}
            maxWidth="lg"
            fullWidth
            PaperProps={{
              sx: {
                borderRadius: 4,
                overflow: "hidden",
              },
            }}
          >
            {/* Header */}
            <Box
              sx={{
                background: "linear-gradient(135deg, #7b1fa2 0%, #ce93d8 100%)",
                color: "#fff",
                px: 3,
                py: 2.5,
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center",
              }}
            >
              <Box>
                <Typography fontSize={20} fontWeight={700}>
                  Add New Features
                </Typography>
                <Typography fontSize={13} sx={{ opacity: 0.9 }}>
                  {externalFeaturesRow?.jeweller?.jewellerName || ""}
                </Typography>
              </Box>
              <IconButton
                onClick={() => setExternalFeaturesDialog(false)}
                sx={{ color: "#fff" }}
              >
                <CloseIcon />
              </IconButton>
            </Box>

            <DialogContent sx={{ p: 3 }}>
              {/* Existing Features — checkbox style like SubscriptionPlan */}
              {/* Features — same logic as Reusable component, all features shown, row features pre-checked & disabled */}
              <Typography
                fontWeight={700}
                fontSize={20}
                mb={3}
                fontFamily="Aeonik"
              >
                Features
              </Typography>
              <Box
                sx={{
                  border: "1px solid #ccc",
                  borderRadius: 2,
                  p: 3,
                  mb: 3,
                  background: "#fff",
                  display: "flex",
                  flexWrap: "wrap",
                  gap: 7,
                }}
              >
                {Object.values(featuresData).map((option) => {
                  const opt = String(option);

                  // same value mapping logic from Reusable component
                  const value =
                    opt === "Sip_OfferType"
                      ? "sip_offertype"
                      : opt === "Sip_Luckey_Draw"
                        ? "sip_luckey_draw"
                        : opt.toLowerCase();

                  // features that already exist on the row — locked
                  // features that already exist on the row OR were purchased externally — locked
                  const rowFeatures = Array.from(
                    new Set([
                      ...(externalFeaturesRow?.features || []).map((f) =>
                        f.toLowerCase(),
                      ),
                      ...(externalSubscriptionData || []).flatMap((item) =>
                        (item.features || []).map((f) => f.toLowerCase()),
                      ),
                    ]),
                  );
                  const isLocked = rowFeatures.includes(value);
                  const isChecked =
                    isLocked || externalSelectedFeatures.includes(value);

                  return (
                    <FormControlLabel
                      key={opt}
                      control={
                        <Checkbox
                          checked={isChecked}
                          disabled={isLocked} // only lock row's existing features
                          onChange={(e) => {
                            if (isLocked) return; // extra guard
                            if (e.target.checked) {
                              setExternalSelectedFeatures((prev) => [
                                ...prev,
                                value,
                              ]);
                            } else {
                              setExternalSelectedFeatures((prev) =>
                                prev.filter((f) => f !== value),
                              );
                            }
                          }}
                          sx={{
                            color: "#7b8499",
                            "&.Mui-checked": {
                              color: isLocked ? "#9c27b0" : "#4caf50",
                            },
                            "&.Mui-disabled.Mui-checked": {
                              color: "#9c27b0",
                            },
                          }}
                        />
                      }
                      label={
                        <Typography
                          variant="body2"
                          fontFamily="Inter"
                          fontSize="14px"
                          fontWeight="500"
                          color="#7b8499"
                        >
                          {option}
                        </Typography>
                      }
                    />
                  );
                })}
              </Box>

              {/* Amount */}
              <TextField
                label="Amount"
                type="number"
                value={externalAmount}
                onChange={(e) => setExternalAmount(e.target.value)}
                fullWidth
                sx={{ mb: 2 }}
                inputProps={{ min: 0 }}
              />

              {/* Comment */}
              <TextField
                label="Comment (Optional)"
                value={externalComment}
                onChange={(e) => setExternalComment(e.target.value)}
                fullWidth
                multiline
                rows={3}
                sx={{ mb: 1 }}
              />
            </DialogContent>

            <DialogActions sx={{ px: 3, pb: 3, gap: 1 }}>
              <Button
                onClick={() => setExternalFeaturesDialog(false)}
                variant="outlined"
                sx={{
                  borderRadius: 2,
                  px: 3,
                  textTransform: "none",
                  fontWeight: 600,
                }}
              >
                Cancel
              </Button>
              <Button
                onClick={handleSubmitExternalFeatures}
                variant="contained"
                color="secondary"
                sx={{
                  borderRadius: 2,
                  px: 3,
                  textTransform: "none",
                  fontWeight: 600,
                }}
              >
                Save
              </Button>
            </DialogActions>
          </Dialog>
          <Dialog
            open={viewFeaturesDialog}
            onClose={() => setViewFeaturesDialog(false)}
            maxWidth="sm"
            fullWidth
            PaperProps={{
              sx: {
                borderRadius: 4,
                overflow: "hidden",
              },
            }}
          >
            {/* Header */}
            <Box
              sx={{
                background: "linear-gradient(135deg, #7b1fa2 0%, #ce93d8 100%)",
                color: "#fff",
                px: 3,
                py: 2.5,
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center",
              }}
            >
              <Box>
                <Typography fontSize={20} fontWeight={700}>
                  Purchased Features
                </Typography>
                <Typography fontSize={13} sx={{ opacity: 0.9 }}>
                  {viewFeaturesList.length} feature
                  {viewFeaturesList.length !== 1 ? "s" : ""} included
                </Typography>
              </Box>
              <IconButton
                onClick={() => setViewFeaturesDialog(false)}
                sx={{ color: "#fff" }}
              >
                <CloseIcon />
              </IconButton>
            </Box>

            <DialogContent sx={{ p: 3, background: "#f8f5fb" }}>
              {viewFeaturesList.length === 0 ? (
                <Box sx={{ textAlign: "center", py: 6 }}>
                  <Typography
                    fontSize={16}
                    fontWeight={700}
                    color="text.secondary"
                  >
                    No Features Found
                  </Typography>
                  <Typography color="text.secondary" mt={1} fontSize={14}>
                    This entry doesn't have any features attached.
                  </Typography>
                </Box>
              ) : (
                <Box
                  sx={{
                    display: "grid",
                    gridTemplateColumns: { xs: "1fr", sm: "1fr 1fr" },
                    gap: 1.5,
                  }}
                >
                  {viewFeaturesList.map((f, i) => (
                    <Box
                      key={i}
                      sx={{
                        display: "flex",
                        alignItems: "center",
                        gap: 1.2,
                        background: "#fff",
                        border: "1px solid #ecdcf5",
                        borderRadius: 2.5,
                        px: 2,
                        py: 1.4,
                        boxShadow: "0 2px 6px rgba(123,31,162,0.06)",
                        transition: "0.2s",
                        "&:hover": {
                          boxShadow: "0 4px 12px rgba(123,31,162,0.12)",
                          borderColor: "#ce93d8",
                        },
                      }}
                    >
                      <Box
                        sx={{
                          width: 28,
                          height: 28,
                          borderRadius: "50%",
                          background:
                            "linear-gradient(135deg, #7b1fa2 0%, #ce93d8 100%)",
                          display: "flex",
                          alignItems: "center",
                          justifyContent: "center",
                          flexShrink: 0,
                        }}
                      >
                        <CheckIcon sx={{ color: "#fff", fontSize: 16 }} />
                      </Box>
                      <Typography
                        fontSize={14}
                        fontWeight={600}
                        color="text.primary"
                        sx={{ textTransform: "capitalize" }}
                      >
                        {String(f).replace(/_/g, " ")}
                      </Typography>
                    </Box>
                  ))}
                </Box>
              )}
            </DialogContent>

            <DialogActions
              sx={{
                px: 3,
                py: 2,
                borderTop: "1px solid #edf2f7",
                background: "#fff",
              }}
            >
              <Button
                variant="contained"
                onClick={() => setViewFeaturesDialog(false)}
                sx={{
                  borderRadius: 2,
                  px: 4,
                  textTransform: "none",
                  fontWeight: 700,
                  background:
                    "linear-gradient(135deg, #7b1fa2 0%, #ce93d8 100%)",
                  "&:hover": {
                    background:
                      "linear-gradient(135deg, #6a1b9a 0%, #ba68c8 100%)",
                  },
                }}
              >
                Close
              </Button>
            </DialogActions>
          </Dialog>
        </Box>
      </Box>
    </Box>
  );
};

export default JewellerSubscription;
